import { apiAsset } from './apiAsset.js'

const API_BASE = import.meta.env.VITE_API_BASE || '/api'

/**
 * Resolve a showcase project's image to a URL.
 *
 * Three kinds of value end up in `showcase_project.project_image` and
 * `preview_images`:
 *
 *   "Project-3.png"          seeded artwork, living in api/spectranoxprojects/
 *   "uploads/1788….png"      uploaded through the CMS, relative to the api folder
 *   "api/uploads/1788….png"  the same thing, written with the folder included
 *
 * Only the first is special to this module — a bare filename is the one case
 * where the folder has to be guessed, and for showcase artwork that folder is
 * spectranoxprojects. Everything else is the same problem every stored path
 * has, so it goes through apiAsset, which knows that a value already starting
 * with `api/` is relative to the site root and must not have the API base
 * prefixed onto it again. Prefixing it produced /api/api/uploads/… and a
 * broken image; nothing writes that shape today, which is exactly why it would
 * have gone unnoticed until the day something did.
 */
export function showcaseImage(src) {
  const v = String(src || '').trim()
  if (!v) return ''
  if (v.includes('/') || /^(https?:)?\/\//i.test(v)) return apiAsset(v)
  return `${API_BASE}/spectranoxprojects/${v}`
}

export default showcaseImage
